import { CASAMAPA_CLIENT_VIEW_SLUG } from "../constants/casamapaPartnerPortalConfig";
import { useAutoMapaPartnerClientView } from "./useAutoMapaPartnerClientView";

export function useAutoMapaCasaMapaAnalyticsView() {
  return useAutoMapaPartnerClientView(CASAMAPA_CLIENT_VIEW_SLUG);
}
